import React from 'react';

import { ReactComponent as WarningRed } from 'assets/icons/warning-red.svg';
import { Modal } from 'components';
import { deleteUser, restoreLocals } from 'store/adminPanel/actions';
import { useDispatch } from 'react-redux';
import { color } from 'echarts';
import { Button } from 'antd';

const RestoreModal = ({ isVisible, setVisible, selectedLocal, setSelectedLocal, setRestored}) => {
  const dispatch = useDispatch();
  
  const handleOk = () => {
    // selectedLocal.map(item => dispatch(deleteUser(item)));
    restoreLocals().then(() => {
      setSelectedLocal("");
      setVisible(false);
      setRestored(true);
    }).catch(error => {
      console.error("Error restoring locals:", error);
    });
  };

  return (
    <Modal
      isVisible={isVisible}
      Icon={WarningRed}
      width={400}
      title={<h1 style={{color:"#EB5757", marginTop:"0.563rem", marginLeft:"0.8rem"}}>Restore</h1>}
      footer={
        <div style={{display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px"}}>
          <Button
            onClick={() => setVisible(false)}
            className="default-button"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {setVisible(false); handleOk()}}
            className="primary-button"
          >
            Restore
          </Button>
        </div>
      }
      className={'invalid-modal'}
    >
      <div className="invalid-modal__body">
        Είστε βέβαιοι ότι επιθυμείτε να επιστρέψετε τα αρχικά λεκτικά;
      </div>
    </Modal>
  );
};

export default RestoreModal;